import { PinFill } from 'react-bootstrap-icons';

function LinkGoogle({ endereco, municipio, cep }) {

    const url = endereco +' '+ municipio + ' ' + cep;

    return (
        <span style={{ marginTop: 25, lineHeight: 1 }}>
            <PinFill /> <a target='_blank' rel="noreferrer" href={"https://maps.google.com/?q=" + url}> {endereco}, {municipio} - {cep} </a>
        </span>
    );
}

export default LinkGoogle;